// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3bsoe","select":"Header_select__2ozQy","clinic":"Header_clinic__1Qvj3"};